import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  Box,
  Fab,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Badge,
} from '@mui/material';
import {
  DirectionsCar,
  Menu as MenuIcon,
  Notifications,
  AccountCircle,
} from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';

const MainLayout: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    logout();
  };

  const navigateToOrder = () => {
    navigate('/app/order');
  };


  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      height: 'auto',
      position: 'relative',
      overflow: 'visible',
    }}>
      <AppBar position="fixed" color="primary" elevation={2} sx={{ zIndex: 1100 }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleMenuOpen}
          >
            <MenuIcon />
          </IconButton>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.8
              }
            }}
            onClick={() => navigate('/app')}
          >
            Ozio
          </Typography>
          <IconButton color="inherit">
            <Badge color="error" variant="dot">
              <Notifications />
            </Badge>
          </IconButton>
          <Avatar
            src={user?.avatar}
            alt={user?.name}
            sx={{ width: 32, height: 32, ml: 1 }}
            onClick={handleMenuOpen}
          />
        </Toolbar>
      </AppBar>

      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => { navigate('/app/profile'); handleMenuClose(); }}>
          <AccountCircle sx={{ mr: 2 }} />
          Profil
        </MenuItem>
        <MenuItem onClick={() => { navigate('/app/payment'); handleMenuClose(); }}>
          <AccountCircle sx={{ mr: 2 }} />
          Ödəniş Üsulları
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <AccountCircle sx={{ mr: 2 }} />
          Çıxış
        </MenuItem>
      </Menu>

      <Box sx={{ 
        flexGrow: 1, 
        pt: 7, 
        pb: 2,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        overscrollBehavior: 'contain',
        position: 'relative',
        minHeight: 'calc(100vh - 56px)',
        '@supports (height: 100dvh)': {
          minHeight: 'calc(100dvh - 56px)',
        },
      }}>
        <Outlet />
      </Box>

      <Fab
        color="primary"
        aria-label="order"
        sx={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 1099,
          minWidth: 56,
          minHeight: 56,
          touchAction: 'manipulation',
          WebkitTapHighlightColor: 'transparent',
          marginBottom: { xs: 'env(safe-area-inset-bottom)', sm: 0 },
        }}
        onClick={navigateToOrder}
      >
        <DirectionsCar />
      </Fab>
    </Box>
  );
};

export default MainLayout;
